import { render, staticRenderFns } from "./WotFabScroll.vue?vue&type=template&id=0f1eea48&scoped=true"
import script from "./WotFabScroll.vue?vue&type=script&lang=js"
export * from "./WotFabScroll.vue?vue&type=script&lang=js"
import style0 from "./WotFabScroll.vue?vue&type=style&index=0&id=0f1eea48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1eea48",
  null
  
)

export default component.exports